import gql from 'graphql-tag';

export const GETPLANACCION = gql`
  query getPlanAccion($semana: String, $empleado: String) {
    planAccion(semana: $semana, empleado: $empleado) {
      id
      tienda
      semana
      empleado
      indicador
      nombreInd
      ventaEmpleado
      ventaTienda
      estado{
        creado
        activo
        cerrado
        completado
      }
      comentario
      actividadMejoramiento
      retroalimentacion
    }
  }
`;


export const ADDPLANACCION = gql`
  mutation addPlan($plan: String) {
    addPlanAccion(plan: $plan) {
      id
    }
  }
`;

export const UPDATEPLANACCION = gql`
  mutation updatePlan($plan: String) {
    updatePlanAccion(plan: $plan) {
      id
    }
  }

`;

export const GETALLPLANSACCION = gql`
  query ($tiendas:[String]){
    planesAccion(tiendas:$tiendas){
      id
      tienda
      semana
      empleado
      indicador
      nombreInd
      ventaEmpleado
      ventaTienda
      estado{
        creado
        activo
        cerrado
        completado
      }
    }
  }
`;

export const GETPLANACCIONXID = gql`
  query ($id: String) {
    planAccionxId(id: $id) {
      id
      tienda
      semana
      empleado
      indicador
      nombreInd
      ventaEmpleado
      ventaTienda
      estado {
        creado
        activo
        cerrado
        completado
      }
      comentario
      actividadMejoramiento
      retroalimentacion
      archivo
      valorTienda
      valorIndicador
    }
  }
`;
